// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import UploadDownloadToolBar from './uploadDownloadToolBar';
import './uploadPaymentSettings.css';
import DragAndDrop from "../../common/simple/dragAndDrop";
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import XLSX from 'xlsx';


export class UploadNewPaymentSetting extends Parent {

    constructor(props) {
        super(props);

        this.state = this.getUploadPaymentState(props);
        this.state.title = '';
        this.getTitle.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
    }
    async componentDidMount() {
        await this.verifyLoggedIn();
        const title = await this.buildingTitleText(this.props.match.params.buildingID);
        this.setState({
            title
        });
    }

    getTitle(){
       const {t} = this.props;

       if (this.state.isOneTime){
          return t('payment_settings.oneTime')
       }else{
           return t('payment_settings.yearly_payment_settings_title', {year: this.state.year})
       }
    }

    async handleDrop(e){

        BllinkLogger.info(`handleDrop in upload settings`, e)
        const buildingID = this.props.match.params.buildingID;
        let year = this.state.year;
        let thisObj = this;
        const hasFilesToUpload = e.dataTransfer.files && e.dataTransfer.files.length>0;
        if (hasFilesToUpload) {
            BllinkLogger.info(` data`, e.dataTransfer)
            let reader = new FileReader();
            reader.readAsBinaryString(e.dataTransfer.files[0]);

            reader.onload = async function (e) {
                let cfb = XLSX.read(e.target.result, {type: 'binary'});
                let sheetData = cfb.Sheets[cfb.SheetNames[0]];
                let jsonData = XLSX.utils.sheet_to_json(sheetData);
                await thisObj.uploadPaymentSettingsFile(year, buildingID, jsonData);
            }
        }

    }

    render() {
        const {t} = this.props;
        const buildingID = this.props.match.params.buildingID;
        let year = this.state.year;

        return (
            <div className="ensure-height">
                <h1 className='page-title'>
                    {this.state.title && (
                        <span className='building-title'>{this.state.title}</span>
                    )}
                </h1>
                <UploadDownloadToolBar
                    year={year}
                    buildingID={buildingID}
                    parentState={this.state}
                />
                <DragAndDrop handleDrop={this.handleDrop}>
                    <div className={"drag-to-upload-container"}>
                        <div className={"drag-to-upload bllink-font"}>
                                <p>{this.getTitle()}</p>
                                <p>{t('payment_settings.uploadHere')}</p>
                        </div>
                    </div>
                </DragAndDrop>
            </div>
        )
    }
}

export default withTranslation()(UploadNewPaymentSetting);

